export default {
  // ShareModal - 分享模態框
  shareModalTitle: '分享 {{petName}} 的照護資訊',
  shareModalSubtitle: '選擇要分享的資訊類型並生成安全連結',
  close: '關閉',
  
  // ShareModal - 啟用分享
  enableSharingFeature: '啟用分享功能',
  sharingPrivacyNotice: '您即將為「{{petName}}」啟用分享功能。這將生成一個安全的分享連結，讓您可以與照護者分享寵物資訊。',
  sharingFeatures: '分享功能特色',
  uniqueSecureLink: '獨特的安全連結',
  selectableInfoTypes: '可選擇的資訊類型',
  disableAnytime: '隨時可停用',
  noPersonalInfoLeak: '不會洩漏您的個人資訊',
  notNow: '暫不啟用',
  enabling: '啟用中...',
  enableSharing: '啟用分享',
  
  // ShareModal - 錯誤訊息
  shareEnableError: '啟用分享功能失敗',
  shareDisableError: '停用分享功能失敗',
  
  // ShareModal - 標籤頁
  shareSelectInfo: '選擇資訊',
  shareVia: '分享方式',
  
  // ShareModal - 選擇資訊
  selectedItems: '已選擇 {{count}} 項',
  shareSelectAll: '全部選擇',
  shareDeselectAll: '全部取消',
  
  // ShareModal - 分享選項
  sharePhoto: '寵物照片',
  sharePhotoDesc: '分享寵物的照片',
  shareBasicInfo: '基本資訊',
  shareBasicInfoDesc: '包含名稱、品種、年齡、性別等基本資料',
  shareDietaryInfo: '飲食資訊',
  shareDietaryInfoDesc: '包含餵食時間表、飲食偏好和禁忌',
  shareBehaviorInfo: '行為資訊',
  shareBehaviorInfoDesc: '包含性格、喜好、運動需求等',
  shareHealthInfo: '健康資訊',
  shareHealthInfoDesc: '包含用藥時間表、疫苗記錄、過敏資訊',
  shareEmergencyContact: '緊急聯絡',
  shareEmergencyContactDesc: '包含獸醫聯絡資訊和保險資料',
  shareSpecialNotes: '特殊備註',
  shareSpecialNotesDesc: '任何其他重要的照護注意事項',
  
  // ShareModal - 預覽
  preview: '預覽',
  previewDescription: '在分享前預覽分享頁面的外觀',
  
  // ShareModal - 分享方式
  chooseShareMethod: '選擇分享方式',
  shareViaEmail: '透過電子郵件',
  shareViaEmailDesc: '使用您的電子郵件客戶端分享',
  shareViaWhatsApp: '透過 WhatsApp',
  shareViaWhatsAppDesc: '在 WhatsApp 上分享',
  shareViaLine: '透過 LINE',
  shareViaLineDesc: '在 LINE 上分享',
  
  // ShareModal - 分享連結
  shareableLink: '分享連結',
  copyLink: '複製連結',
  copied: '已複製',
  generating: '生成中...',
  
  // ShareModal - 分享訊息模板
  emailSubject: '{{petName}} 的照護資訊',
  emailBody: '您好！\n\n我想與您分享 {{petName}} 的照護資訊。請點擊以下連結查看：\n\n{{shareUrl}}\n\n謝謝！',
  whatsappMessage: '您好！我想與您分享 {{petName}} 的照護資訊：{{shareUrl}}',
  lineMessage: '{{petName}} 的照護資訊',
  
  // ShareModal - 安全提示
  securityReminder: '安全提醒',
  shareOnlyWithTrusted: '請僅與您信任的照護者分享此連結。您可以隨時停用分享功能。',
  
  // ShareModal - 停用分享
  disableSharing: '停用分享',
  processing: '處理中...',
  confirmDisable: '確認停用',
  
  // DisableShareConfirmModal - 停用分享確認
  disableSharingTitle: '停用分享功能',
  disableSharingMessage: '您確定要停用此寵物的分享功能嗎？',
  shareLinksInvalid: '所有現有的分享連結將立即失效',
  viewersLoseAccess: '已獲得連結的人將無法再查看資料',
  cancel: '取消',
  
  // DeleteConfirmModal - 刪除確認
  confirmDelete: '確認刪除',
  cannotUndo: '此操作無法復原',
  deletePetData: '刪除寵物資料',
  confirmDeletePetMessage: '您確定要刪除「{{petName}}」的所有資料嗎？',
  willLoseAfterDelete: '刪除後您將失去：',
  allBasicData: '所有基本資料和照片',
  healthRecordsAndVaccines: '健康記錄和疫苗資訊',
  careInstructionsAndNotes: '照護指示和備註',
  uploadedPhotos: '已上傳的照片',
  shareLinksWillExpire: '所有分享連結將失效',
  deleting: '刪除中...',
  deleteWarningMessage: '請謹慎操作，刪除的資料無法恢復',
  unnamedPet: '未命名寵物',
  
  // LogoutConfirmModal - 登出確認
  confirmLogout: '確認登出',
  logoutConfirmMessage: '您確定要登出嗎？您將需要重新登入才能訪問您的寵物資料。',
  logout: '登出',
  loggingOut: '登出中...',
};